import React, { useState, useRef } from 'react';
import { Button, CircularProgress, Snackbar, Alert } from '@mui/material';
import OpenAI from 'openai';

function UploadImageButton() {
  const [isProcessing, setIsProcessing] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file is an image
    if (!file.type.startsWith('image/')) {
      setNotification({
        open: true,
        message: 'Please select an image file',
        severity: 'error'
      });
      return;
    }

    setIsProcessing(true);
    try {

      const reader = new FileReader();
      reader.readAsDataURL(file);
      
      const base64Image = await new Promise((resolve, reject) => {
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
      });

      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch('/api/parse-image', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ base64Image }),
      });

      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.error || `Server responded with ${response.status}`);
      }

      const data = await response.json();
      if (data.status === 'completed') {
        window.location.reload(); // needs to be reloaded to pull in most recent data
      } else {
        console.log('Server response:', data);
        throw new Error('Invalid response format from server');
      }
    } catch (error) {
      console.error('Error processing image:', error);
      setNotification({
        open: true,
        message: error.message || 'Error processing image',
        severity: 'error'
      });
    } finally {
      setIsProcessing(false);
      // Clear the file input
      event.target.value = '';
    }
  };

  const handleCloseNotification = () => {
    setNotification(prev => ({ ...prev, open: false }));
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        accept="image/*"
      />
      <Button
        variant="contained"
        onClick={handleButtonClick}
        disabled={isProcessing}
        startIcon={isProcessing ? <CircularProgress size={20} /> : null}
      >
        {isProcessing ? 'Processing Image...' : 'Upload Schedule Image'}
      </Button>
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
      >
        <Alert onClose={handleCloseNotification} severity={notification.severity}>
          {notification.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default UploadImageButton;
